export const bulkBeneficiaryFirstHeader = [
  "s.no",
  "beneficiary details",
  "amount details",
  "",
];

export const bulkBeneficiaryMainHeader = [
  "name as per bank",
  "account number",
  "ifsc",
  "amount in inr",
  "payment method",
  "",
  "name",
  "account",
  "amount",
  "payment",
  "method",
];

export const bulkCustomerMainHeader = [
  "s.no",
  "first name",
  "last name",
  "mobile number",
  "virtual id (customer)\nupto 10 digit",
  "select payin\nmethod",
  "select payin method",
  "enter upi id\n(optinal)",
  "enter upi id (optinal)",
  "advance valdation",
  "auto close",
  "third party\nvalidation (bank account) upto 10",
  "virtual id (customer) upto 10 digit",
  "third party validation (bank account) upto 10",
  // "enter upi id",
  // "virtual id",
  // "virtual id upto 10 digit",

  "close date",
  "merchant name",
  "brand name",
  "no",
  "sno",
  "",
];

export const bulkCustomerFirstHeader = [
  "enable payin",
  "advance validation",
  "if upi is enabled",
  "",
  "basic details",
];

export const bulkCustomerArrayName = [
  {
    "virtual id (prefix)": {
      name: "",
    },
  },

  {
    "close date": {
      name: "closeByDate",
    },
  },
];

const convertFromExpToNumber = (n) => {
  n = Number(n);
  let str = "";
  var sign = +n < 0 ? "-" : "",
    toStr = n.toString();
  if (!/e/i.test(toStr)) {
    return n.toString();
  }
  var [lead, decimal, pow] = n
    .toString()
    .replace(/^-/, "")
    .replace(/^([0-9]+)(e.*)/, "$1.$2")
    .split(/e|\./);

  str =
    +pow < 0
      ? sign +
        "0." +
        "0".repeat(Math.max(Math.abs(pow) - 1 || 0, 0)) +
        lead +
        decimal
      : sign +
        lead +
        (+pow >= decimal.length
          ? decimal + "0".repeat(Math.max(+pow - decimal.length || 0, 0))
          : decimal.slice(0, +pow) + "." + decimal.slice(+pow));
  return str.toString();
};

export const spaceRemover = (s) => {
  let str = s.replace(/\n/g, " ");
  let newStr = "";
  str.split(" ").map((str, i) => {
    if (str !== "") newStr = newStr + " " + str;
  });
  return newStr.trim();
};

const paymentType = ["imps", "rtgs", "neft", "upi"];
export function getFileExtension(filename) {
  var ext = /^.+\.([^.]+)$/.exec(filename);
  return ext == null ? "" : ext[1];
}

export const bulkDataModifier = (fileData = {}) => {
  console.log(fileData, "s");
};

export const bulkDataModifierForBeneficiary = (fileData = []) => {
  console.log("entered");
  let arrData = [];
  let obj = {};
  let nameRegex = /^[a-zA-Z0-9 ]+$/;
  let alphaNumRegex = /^[0-9A-Za-z]+$/;
  let numRegex = /^[0-9]+$/;

  fileData?.map((data, i) => {
    if (
      nameRegex.test(data[1]) &&
      (alphaNumRegex?.test(convertFromExpToNumber(data[2])) ||
        numRegex?.test(convertFromExpToNumber(data[2]))) &&
      convertFromExpToNumber(data[2]).length > 8 &&
      convertFromExpToNumber(data[2]).length < 20 &&
      alphaNumRegex?.test(data[3]) &&
      data[3]?.length === 11 &&
      numRegex?.test(convertFromExpToNumber(data[4])) &&
      paymentType.includes(data[5]?.toLowerCase())
    ) {
      obj = {
        beneficiaryName: data[1],
        accountNumber: convertFromExpToNumber(data[2])?.toString(),
        ifscCode: data[3],
        amount: convertFromExpToNumber(data[4])?.toString(),
        type: data[5],
      };
      arrData.push(obj);
    }
  });

  console.log(arrData, "bulk  arrData");
  return arrData;
};

const payInMethods = ["both", "upi", "van"];
const yesOrNo = ["yes", "no", "y", "n"];

const getStringAtGivenIndex = (oldStr, i) => {
  let str = oldStr.split(",");
  return str[i];
};

const getAccountAndIfscCode = (oldStr, oldStrIfsc) => {
  let ArrayObj = [];
  let strAcc = oldStr.split(",");
  let strIfsc = oldStrIfsc.split(",");
  let len = strAcc.length > strIfsc.length ? strAcc.length : strIfsc.length;
  let numRegex = /^[0-9]+$/;
  let alphaNumRegex = /^[0-9A-Za-z]+$/;

  for (let i = 0; i < len; i++) {
    let s1 = strIfsc[i] ? strIfsc[i]?.trim() : "";
    let s2 = strAcc[i] ? strAcc[i]?.trim() : "";

    console.log(
      s1 !== "",
      s2 !== "",
      alphaNumRegex.test(convertFromExpToNumber(s2)) ||
        numRegex.test(convertFromExpToNumber(s2)),
      alphaNumRegex.test(s1),
      convertFromExpToNumber(s2)
    );
    if (
      s1 !== "" &&
      s2 !== "" &&
      (alphaNumRegex.test(convertFromExpToNumber(s2)) ||
        numRegex.test(convertFromExpToNumber(s2))) &&
      alphaNumRegex.test(s1)
    )
      ArrayObj = [
        ...ArrayObj,
        {
          ifscCode: s1,
          accountNumber: convertFromExpToNumber(s2),
        },
      ];
  }
  console.log(ArrayObj, "ArrayObjArrayObj");
  return ArrayObj;
};

export const customerBulkModifier = (fileData = [], vid) => {
  let arrData = [];
  let obj = {};
  let nameRegex = /^[a-zA-Z0-9 ]+$/;
  let numRegex = /^[0-9]+$/;

  fileData?.map((data, i) => {
    if (
      (nameRegex.test(data[1]) && //first name
        nameRegex.test(data[2]) && //last name
        numRegex.test(convertFromExpToNumber(data[3])) &&
        data[3].length === 10 && // mobile number
        numRegex.test(convertFromExpToNumber(data[4])) &&
        data[4].length <= 10 && // virtual id
        payInMethods.includes(data[5].toLowerCase()) && // yes or no (van or upi or both)
        yesOrNo.includes(data[7].toLowerCase()),
      (data[6] !== ""
        ? numRegex.test(convertFromExpToNumber(data[6]))
        : true) && yesOrNo.includes(data[8].toLowerCase()))
      //auto close
    ) {
      let isUpiSelected = payInMethods.includes(data[5].toLowerCase())
        ? data[5].toLowerCase() === "van"
          ? false
          : true
        : false;

      let isAutoCloseSelected =
        data[8]?.toLowerCase() === "yes" || data[8]?.toLowerCase() === "y"
          ? true
          : false;
      let paymentDetailsArr = [];
      let upiDetailsObj = {
        merchantName: isUpiSelected ? data[12] : "",
        mcc: "6540",
        brandName: isUpiSelected ? data[13] : "",
        legalName: "Neokred Technologies Private Limited",
        franchise: "NEOKRED",
        merchantType: "LARGE",
        ownerShipType: "PRIVATE",
        genre: "ONLINE",
        onboardingType: "Aggregator",
      };

      let upiNumber =
        data[6] !== ""
          ? convertFromExpToNumber(data[6])
          : convertFromExpToNumber(data[4]);
      let vpa = vid + convertFromExpToNumber(data[4]);
      let upi = vid + upiNumber + "@yesbankltd";

      paymentDetailsArr.push({
        upiDetails: upiDetailsObj,
        paymentMode: "VAN",
        paymentId: vpa,
      });

      if (isUpiSelected) {
        paymentDetailsArr.push({
          upiDetails: upiDetailsObj,
          paymentMode: "UPI",
          paymentId: upi,
        });
      }
      obj = {
        id: i + 1,
        firstName: data[1],
        lastName: data[2],
        mobileNumber: convertFromExpToNumber(data[3]),
        autoCloseStatus: isAutoCloseSelected
          ? data[11] !== ""
            ? true
            : false
          : false,
        closeByDate: isAutoCloseSelected
          ? data[11] !== ""
            ? data[11]
            : ""
          : "",
        bankDetails: getAccountAndIfscCode(data[9], data[10]),
        paymentDetails: [...paymentDetailsArr],
      };
      arrData.push(obj);
    } else {
      console.log("no match");
    }
  });
  console.log(arrData, "arrData");

  return arrData;
};

export const stringSlicer = (str, len) => {
  if (str.length > len) {
    return str.slice(0, len) + "...";
  } else return str;
};

export const totalAmountCalculator = (arr) => {
  let amount = 0;
  let regex = /^[0-9]+$/;
  arr?.map((val, i) => {
    if (regex.test(val?.amount)) amount = Number(val?.amount) + amount;
    else amount = 0 + amount;
  });
  return amount;
};
